export const FAQ_GROUPS = [
  {
    group: "Services",
    items: [
      ["What does SparkIdea Interactive do?", "We build our own software ventures — like Nautis, DemoVexa, and Qikod — and we help founders design, build, launch, and scale their products. We also provide fractional CTO support and, selectively, partner with founders to co-build new ventures."],
      ["Do you build products for startups?", "Yes. Most of our service work is with startups: shaping the first version of a product, building MVPs and SaaS platforms, and strengthening products that already have users."],
      ["Can you help a non-technical founder?", "Yes. We translate an idea into requirements, architecture, a working product, and a launch plan — and explain technical trade-offs in plain language so you can make informed decisions."],
      ["What types of software can you develop?", "Web applications, SaaS platforms, AI-powered products, internal tools, APIs, and integrations. If your project is outside our strengths, we'll tell you."],
      ["Do you work with existing SaaS products?", "Yes — adding features, integrating AI, improving architecture and performance, or rescuing a product that has stalled."],
      ["Can you provide a fractional CTO?", "Yes. The scope, availability, and responsibilities are agreed at the start of each engagement."],
    ],
  },
  {
    group: "Development process",
    items: [
      ["How do projects begin?", "With a conversation about what you're building and where you're stuck. If there's a fit, we usually recommend a short discovery phase to agree on scope, approach, and an estimate before development starts."],
      ["Can you work with our existing engineering team?", "Yes. We can work alongside your developers, provide technical leadership, or take ownership of a defined part of the product."],
      ["Who owns the code?", "Ownership terms are defined in the agreement for each engagement. For client projects, the default intention is that you own what you pay us to build."],
    ],
  },
  {
    group: "Pricing and engagement",
    items: [
      ["How do you estimate project costs?", "Cost depends on scope, complexity, integrations, design depth, and timeline. We don't publish fixed prices; after discovery we propose a scope, milestones, and an estimate you can evaluate."],
      ["What engagement models do you offer?", "Project-based work, monthly engineering partnerships, fractional CTO support, discovery engagements, and — selectively — venture partnerships."],
    ],
  },
  {
    group: "AI and technology",
    items: [
      ["Do you work with AI and automation?", "Yes. We build AI features, agents, retrieval-augmented generation, and workflow automation — with evaluation and monitoring so you know how well they actually work."],
      ["Will AI make our product better?", "Sometimes. We'll help you find where AI creates real value for users and where it would only add cost or risk."],
    ],
  },
  {
    group: "Venture partnerships",
    items: [
      ["Can you partner with founders for equity?", "Selectively. Some partnerships may involve cash-plus-equity or other arrangements, but every opportunity is evaluated individually and no arrangement is guaranteed."],
      ["What should I include when pitching an idea?", "The problem, who has it, why now, your stage, and your team. Please don't share confidential trade secrets in the initial application."],
    ],
  },
  {
    group: "International collaboration",
    items: [
      ["Do you work with international clients?", "Yes. We collaborate remotely and agree on communication rhythms, overlapping hours, and tools at the start of every engagement."],
    ],
  },
];

export const HOME_FAQS = [
  ...FAQ_GROUPS[0].items,
  FAQ_GROUPS[3].items[0],
  FAQ_GROUPS[4].items[0],
  FAQ_GROUPS[1].items[0],
  FAQ_GROUPS[5].items[0],
  FAQ_GROUPS[2].items[0],
  FAQ_GROUPS[1].items[1],
];
